<div class="flex min-h-0 flex-col gap-4 pb-4">
  @for (behandler of behandlerData(); track behandler.index) {
    <div
      (click)="onClickBehandlerCard(behandler)"
      [attr.data-testid]="'behandler-card-' + behandler.index"
      class="behandler-card drop-shadow-card flex h-fit w-full flex-col gap-2 rounded-xl bg-white p-4">
      <div class="headline flex flex-row gap-2">
        <div class="id">{{ behandler.displayId }}</div>
        <div
          class="headline-text truncate whitespace-nowrap"
          sharedCoreTooltipOnContentOverflow
          [displayedValue]="behandler.fullHeadline ?? ''"></div>
        <div class="action-bar flex flex-row gap-2">
          <button
            type="button"
            [attr.data-testid]="'behandler-edit-button-' + behandler.index"
            (click)="onClickEdit($event, behandler)">
            <img
              ngSrc="../../../../../assets/icons/pencil.svg"
              width="24"
              height="24"
              alt="Bearbeiten" />
          </button>
          <button
            type="button"
            [attr.data-testid]="'behandler-delete-button-' + behandler.index"
            (click)="onClickDelete($event, behandler)">
            <img
              ngSrc="../../../../../assets/icons/trash.svg"
              width="19"
              height="19"
              alt="Löschen"
              class="delete-icon" />
          </button>
        </div>
      </div>

      <div class="grid grid-cols-11 gap-y-2">
        <div class="data-item col-span-4">
          <b>Fachgebiet:</b>
          <div
            sharedCoreTooltipOnContentOverflow
            class="truncate whitespace-nowrap"
            [displayedValue]="behandler.fachgebiet ?? ''"></div>
        </div>
        <!--        <div class="data-item col-span-7">-->
        <!--          <b>Art:</b>-->
        <!--          <div-->
        <!--            sharedCoreTooltipOnContentOverflow-->
        <!--            class="truncate whitespace-nowrap"-->
        <!--            [displayedValue]="behandler.art ?? ''"></div>-->
        <!--        </div>-->
      </div>

      <hr class="text-theme-light-gray" />

      <div class="grid grid-cols-11 gap-y-2">
        <div class="data-item col-span-4">
          <b>Telefon:</b>
          <div
            sharedCoreTooltipOnContentOverflow
            class="truncate whitespace-nowrap"
            [displayedValue]="behandler.telefon ?? ''"></div>
        </div>
        <div class="data-item col-span-4">
          <b>E-Mail:</b>
          <div
            sharedCoreTooltipOnContentOverflow
            class="truncate whitespace-nowrap"
            [displayedValue]="behandler.email ?? ''"></div>
        </div>
        <div class="data-item col-span-3">
          <b>Fax:</b>
          <div
            sharedCoreTooltipOnContentOverflow
            class="truncate whitespace-nowrap"
            [displayedValue]="behandler.fax ?? ''"></div>
        </div>
      </div>
    </div>
  }
</div>

<div class="bottom-bar flex w-full flex-row gap-4">
  <button
    type="button"
    class="w-full"
    sharedCoreButton
    variant="secondary"
    data-testid="behandler-skip-button"
    (click)="onClickSkipBehandler()">
    KEINEM BEHANDLER ZUORDNEN (LEERTASTE)
  </button>
  <button
    type="button"
    class="w-full"
    sharedCoreButton
    variant="primary"
    data-testid="behandler-add-button"
    (click)="onClickAddBehandler()">
    NEUEN BEHANDLER HINZUFÜGEN (N)
  </button>
</div>
